import { TemplateConfig } from '../types';

export const cheatingCheckSpreadConfig: TemplateConfig = {
  id: 'cheating-check-spread',
  name: '检验出轨牌阵',
  description: '检验感情中的忠诚与未来走向',
  cardCount: 5,

  fieldDefaults: {
    title: '检验出轨牌阵',
    customerQuestion: '在一段关系里没有安全感的状态下，检验感情中的忠诚与未来走向。',
    cardPlaceholders: [
      '请输入第 1 列第 1 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 2 列第 2 张牌',
      '请输入第 3 列第 2 张牌'
    ],
    cardInfos: [
      '对方内心对这段感情有动摇过吗',
      '对方对我是真心的吗',
      '对方身边有第三方吗',
      '这段感情的阻碍',
      '未来发展以及走向'
    ]
  },

  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],

  generateOptions: {
    normal: true,
    thinking: true
  },

  ui: {
    color: '#fa541c',
    backgroundColor: '#fff2e8',
    icon: '🔍'
  }
};
